import type { AuthStatus } from '../../shell/AppShell.js';
import { IconGlyph } from '../../ui/primitives/index.js';

export function StartupScreen(props: { authStatus: AuthStatus; onRetry: () => void }) {
  const failed = props.authStatus === 'failed';
  return (
    <article className="mira-startup-screen" aria-label="Mira launch screen">
      <div className="mira-startup-leaves" aria-hidden="true" />
      <section className="mira-startup-center">
        <h1>Mira</h1>
        <p>See within.<br />See your relationships and this moment clearly.</p>
        <span className="mira-startup-divider" aria-hidden="true"><IconGlyph value="♧" /></span>
        <div className="mira-startup-loader" aria-hidden="true"><span><IconGlyph value="♧" /></span></div>
        <strong>{failed ? 'Your space could not be prepared right now.' : 'Preparing your space…'}</strong>
      </section>
      <footer className="mira-startup-footer">
        <span aria-hidden="true"><IconGlyph value="♡" /></span>
        <p>Connection trouble?</p>
        <button onClick={props.onRetry} type="button">Try again <IconGlyph value="›" /></button>
      </footer>
    </article>
  );
}
